import { render, staticRenderFns } from "./OrderB2B.vue?vue&type=template&id=1e1b0de1&"
import script from "./OrderB2B.vue?vue&type=script&lang=js&"
export * from "./OrderB2B.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports